"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("lodash/bind"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _x = _interopRequireDefault(require("@spothero/icons/x"));
var _dom = _interopRequireDefault(require("@spothero/utils/dom"));
var _Button = _interopRequireDefault(require("../v1/components/Button/Button"));
var _Portal = _interopRequireDefault(require("../Portal/Portal"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Tooltip extends _react.Component {
  static defaultProps = {
    position: 'top',
    showClose: true,
    tipOffset: 0,
    adjustArrow: true
  };
  constructor(props) {
    super(props);
    this._isArrowAdjusted = false;
  }
  componentDidMount() {
    const {
      triggerSelector,
      updateOnMove,
      closeOnBodyClick
    } = this.props;
    this._trigger = _dom.default.el(triggerSelector);
    this._positionTooltip();
    _dom.default.addClass(this._container, 'Tooltip-showing');
    if (updateOnMove) {
      this._container.style.position = 'fixed';
      this._scrollInterval = setInterval((0, _bind.default)(this._positionTooltip, this), 100);
    }
    if (closeOnBodyClick) {
      document.addEventListener('click', this._onCloseClick, {
        capture: true
      });
    }
  }
  componentWillUnmount() {
    const {
      updateOnMove,
      closeOnBodyClick
    } = this.props;
    if (updateOnMove) {
      clearInterval(this._scrollInterval);
    }
    if (closeOnBodyClick) {
      document.removeEventListener('click', this._onCloseClick);
    }
  }
  _onCloseClick = evt => {
    this.hide();
  };
  _positionTooltip() {
    if (!this._trigger) {
      return;
    }
    const {
      position,
      tipOffset,
      updateOnMove,
      adjustArrow
    } = this.props;
    const {
      top: clientTop,
      left: clientLeft,
      right: clientRight,
      bottom: clientBottom,
      width,
      height
    } = this._trigger.getBoundingClientRect();
    const tooltipWidth = this._container.offsetWidth;
    const tooltipHeight = this._container.offsetHeight;
    const {
      top: documentTop,
      left: documentLeft
    } = _dom.default.getDocumentOffset(this._trigger);
    const top = updateOnMove ? clientTop : documentTop;
    const right = updateOnMove ? clientRight : documentLeft + width;
    const bottom = updateOnMove ? clientBottom : documentTop + height;
    const left = updateOnMove ? clientLeft : documentLeft;
    const containerMid = position === 'top' || position === 'bottom' ? tooltipWidth / 2 : tooltipHeight / 2;
    const bodyWidth = document.body.clientWidth;
    const adjuster = 5;
    let newTop = 0;
    let newLeft = 0;
    switch (position) {
      case 'top':
        newTop = top - tooltipHeight - tipOffset;
        newLeft = left + width / 2 - containerMid;
        break;
      case 'right':
        newTop = top + height / 2 - containerMid;
        newLeft = right + tipOffset;
        break;
      case 'bottom':
        newTop = bottom + tipOffset;
        newLeft = left + width / 2 - containerMid;
        break;
      case 'left':
        newTop = top + height / 2 - containerMid;
        newLeft = left - tooltipWidth - tipOffset;
        break;
    }

    // adjust tooltip position if off the left side of the screen
    let adjustedLeft = newLeft < 0 ? adjuster : newLeft;

    // adjust tooltip position if off the right side of the screen
    if (tooltipWidth > bodyWidth - adjustedLeft) {
      adjustedLeft = bodyWidth - tooltipWidth - adjuster;
    }
    this._container.style.top = `${newTop}px`;
    this._container.style.left = `${adjustedLeft}px`;
    if (adjustArrow && !this._isArrowAdjusted && adjustedLeft !== newLeft && (position === 'top' || position === 'bottom')) {
      this._arrow.style.left = `${this._arrow.getBoundingClientRect().left + (newLeft - adjustedLeft)}px`;
      this._isArrowAdjusted = true;
    }
  }

  /**
   * Hides the Tooltip programmatically and fires the `onHidden` callback when done.
   *
   * @public
   * @returns {void}
   */
  hide() {
    if (_dom.default.hasClass(this._container, 'Tooltip-showing')) {
      _dom.default.removeClass(this._container, 'Tooltip-showing');
      setTimeout(() => {
        this.props.onHidden();
      }, 250);
    }
  }
  render() {
    const {
      className,
      containerClassName,
      position,
      showClose,
      children
    } = this.props;
    const classes = (0, _classnames.default)('Tooltip', `Tooltip-${position}`, {
      'Tooltip-no-close': !showClose
    }, className);
    return /*#__PURE__*/_react.default.createElement(_Portal.default, {
      className: containerClassName
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._container = node;
      },
      className: classes,
      role: "tooltip"
    }, /*#__PURE__*/_react.default.createElement("div", {
      ref: node => {
        this._arrow = node;
      },
      className: "Tooltip-arrow"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "Tooltip-content"
    }, children, showClose && /*#__PURE__*/_react.default.createElement(_Button.default, {
      className: "Tooltip-close",
      onClick: this._onCloseClick
    }, /*#__PURE__*/_react.default.createElement(_x.default, null)))));
  }
}
exports.default = Tooltip;